import { createSelector } from '@reduxjs/toolkit';
import { isFormValidatedSelector } from '../forms/selectors';
import { isFlightsValidatedSelector } from '../flights/selectors';
import { InsuranceStep, STEPS_STATE_NAMESPACE } from './index';
const stepsSelector = (state) => state[STEPS_STATE_NAMESPACE];
export const currentStepSelector = createSelector(stepsSelector, ({ currentStep }) => currentStep);
export const insuranceStepsSelector = createSelector(currentStepSelector, isFlightsValidatedSelector, isFormValidatedSelector, (currentStep, isFlightsValidated, isFormValidated) => {
    const steps = [
        {
            formStepKey: InsuranceStep.flights,
            title: 'Рейсы',
            isNextDisabled: !isFlightsValidated,
        },
        {
            formStepKey: InsuranceStep.forms,
            title: 'Пассажиры',
            isNextDisabled: !isFormValidated,
        },
        {
            formStepKey: InsuranceStep.details,
            title: 'Опции',
            isNextDisabled: false,
        },
    ].map((step) => ({
        ...step,
        isActive: step.formStepKey === currentStep,
    }));
    return steps;
});
export const nextStepSelector = createSelector(currentStepSelector, insuranceStepsSelector, (currentStep, steps) => {
    const currentStepIndex = steps.findIndex((step) => step.formStepKey === currentStep);
    const nextStepCode = steps[currentStepIndex + 1]?.formStepKey;
    return nextStepCode || null;
});
export const previousStepSelector = createSelector(currentStepSelector, insuranceStepsSelector, (currentStep, steps) => {
    const currentStepIndex = steps.findIndex((step) => step.formStepKey === currentStep);
    const previousStepCode = steps[currentStepIndex - 1]?.formStepKey;
    return previousStepCode || null;
});
export const isLastStepSelector = createSelector(nextStepSelector, (nextStep) => !nextStep);
